import { apiClient } from '@app/lib'
import { useSugarContext } from '@app/providers'
import { type SugarExpenditureInput, type SugarSaveExpenditureResponse } from '@app/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useSaveExpenditure = () => {
  const queryClient = useQueryClient()
  const sugar = useSugarContext()

  return useMutation({
    mutationKey: ['saveExpenditure'],
    mutationFn: async (input: SugarExpenditureInput) => {
      const { data } = await apiClient.post<SugarSaveExpenditureResponse>('/api/expenditures', input)

      return data
    },
    onSuccess: async (data) => {
      const { schoolYearId, quarterId, providerId } = data.data

      queryClient.setQueryData(
        ['expenditure', sugar?.isProviderRequired ? [schoolYearId, quarterId, providerId] : [schoolYearId, quarterId]],
        data
      )

      await queryClient.invalidateQueries({
        queryKey: ['expenditures']
      })

      return data
    }
  })
}
